import api from "./axiosConfig";

const handleError = (type, error) => {
  console.error(`${type} request failed:`, error);
  throw error;
};

/**
 * Generic function to make a GET request with axios.
 * @param {string} url - The URL of the API endpoint.
 * @param {Object} [params={}] - URL parameters for GET requests.
 * @param {Object} [headers={}] - Custom headers to include in the request.
 * @returns {Promise<Object>} The response data from the API call.
 */
export const getRequest = async (url, params = {}, headers = {}) => {
  try {
    const response = await api.get(url, { params, headers });
    return response.data;
  } catch (error) {
    handleError("GET", error);
  }
};

/**
 * Generic function to make a POST request with axios.
 * @param {string} url - The URL of the API endpoint.
 * @param {Object} [data={}] - The data to send in the request body (for POST requests).
 * @param {Object} [headers={}] - Custom headers to include in the request.
 * @returns {Promise<Object>} The response data from the API call.
 */
export const postRequest = async (url, data = {}, headers = {}) => {
  try {
    const response = await api.post(url, data, { headers });
    return response.data;
  } catch (error) {
    handleError("POST", error);
  }
};

/**
 * Generic function to make a PATCH request with axios.
 * @param {string} url - The URL of the API endpoint.
 * @param {Object} [data={}] - The data to send in the request body (for PATCH requests).
 * @param {Object} [headers={}] - Custom headers to include in the request.
 * @returns {Promise<Object>} The response data from the API call.
 */
export const patchRequest = async (url, data = {}, headers = {}) => {
  try {
    const response = await api.patch(url, data, { headers });
    return response.data;
  } catch (error) {
    handleError("PATCH", error);
  }
};

/**
 * Generic function to make a DELETE request with axios.
 * @param {string} url - The URL of the API endpoint.
 * @param {Object} [headers={}] - Custom headers to include in the request.
 * @returns {Promise<Object>} The response data from the API call.
 */
export const deleteRequest = async (url, headers = {}) => {
  try {
    const response = await api.delete(url, { headers });
    return response.data;
  } catch (error) {
    handleError("DELETE", error);
  }
};
